module.exports = __webpack_public_path__ + "static/media/hvac-heating-cooling-systems-articles.1e503700.jpg";